<template>
  <div class="component-container">
    <div v-if="showButtons" class="button-group-container">
      <el-popconfirm
        :title="$t('table.CREATE_A_LINE_DESCRIPTION')"
        @confirm="handleCreate"
        popper-class="popper"
      >
        <el-button
          v-if="createButton"
          class="button"
          type="primary"
          round
          :disabled="createButtonDisabled"
          slot="reference"
          >{{ $t('table.CREATE_A_LINE') }}
        </el-button>
      </el-popconfirm>
      <el-popconfirm
        :title="$t('table.COPY_A_LINE_DESCRIPTION')"
        @confirm="handleCopy"
        popper-class="popper"
      >
        <el-button
          v-if="copyButton"
          class="button"
          type="primary"
          round
          :disabled="copyButtonDisabled"
          slot="reference"
          >{{ $t('table.COPY_A_LINE') }}</el-button
        >
      </el-popconfirm>
      <el-popconfirm
        :title="$t('table.DELETE_LINES_DESCRIPTION')"
        @confirm="handleDelete"
        popper-class="popper"
      >
        <el-button
          v-if="deleteButton"
          class="button"
          type="danger"
          round
          :disabled="deleteButtonDisabled"
          slot="reference"
          >{{ $t('table.DELETE_LINES') }}</el-button
        >
      </el-popconfirm>
    </div>
    <el-table
      class="table"
      :header-row-style="{ height: '40px', lineHeight: '40px' }"
      :max-height="tableMaxHeight"
      :data="rows"
      :key="itemkey"
      border
      highlight-current-row
      @cell-click="handleCellClick"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="45"
        :resizable="false"
        align="center"
      />
      <el-table-column
        type="index"
        width="45"
        label=" "
        :resizable="false"
        align="center"
      />
      <el-table-column
        v-for="(column, index) in columns"
        :prop="column.colId"
        :label="column.label"
        :label-class-name="column.required ? 'isrequired' : null"
        :key="index"
        :width="column.width"
        :resizable="false"
        :header-align="column.headerAlign"
        :align="column.align"
      >
        <template slot-scope="scope">
          <span
            v-if="showCellContent(null, scope.$index, index)"
            class="cell-content"
            :style="fontColor(scope.$index, index)"
            >{{ checkValue(scope.row[column.colId].value, index) }}</span
          >
          <jtInput
            v-if="showCellContent('jtInput', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :minLength="column.component.property.minLength"
            :maxLength="column.component.property.maxLength"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-email
            v-if="showCellContent('jtEmail', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-phone
            v-if="showCellContent('jtPhone', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-date
            v-if="showCellContent('jtDate', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :format="column.component.property.format"
            :defaultValue="column.component.property.defaultValue"
            :minLength="column.component.property.minLength"
            :maxLength="column.component.property.maxLength"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-time
            v-if="showCellContent('jtTime', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :format="column.component.property.format"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-date-time
            v-if="showCellContent('jtDateTime', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :format="column.component.property.format"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-id-card
            v-if="showCellContent('jtIdCard', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :types="column.component.property.types"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @IDCheck="(data) => handleIDCheck(data, scope.$index, index)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-id-card-global
            v-if="showCellContent('jtIdCardGlobal', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-single-project
            v-if="showCellContent('jtSingleProject', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :minLength="column.component.property.minLength"
            :maxLength="column.component.property.maxLength"
            :suggestions="column.component.property.suggestions"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jt-group-project
            v-if="showCellContent('jtGroupProject', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :minLength="column.component.property.minLength"
            :maxLength="column.component.property.maxLength"
            :suggestions="column.component.property.suggestions"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtSelect
            v-if="showCellContent('jtSelect', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtGroupSelect
            v-if="showCellContent('jtGroupSelect', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtImage
            v-if="showCellContent('jtImage', scope.$index, index)"
            :src="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :thumbnailWidth="column.component.property.thumbnailWidth"
            :thumbnailHeight="column.component.property.thumbnailHeight"
            :uploadAction="scope.row[column.colId].uploadAction"
            :supportTypes="column.component.property.supportTypes"
            :editable="column.editable && scope.row[column.colId].editable"
            :supportSize="column.component.property.supportSize"
            :types="column.component.property.types"
            :supportMinWidth="Number(column.component.property.supportMinWidth)"
            :supportMaxWidth="Number(column.component.property.supportMaxWidth)"
            :supportMinHeight="
              Number(column.component.property.supportMinHeight)
            "
            :supportMaxHeight="
              Number(column.component.property.supportMaxHeight)
            "
            :scaleWH="column.component.property.scaleWH"
            @delete="() => handleImageDelete(scope.$index, index)"
            @success="
              (response) =>
                handleImageUploadSuccess(scope.$index, index, response)
            "
            @change="
              (file, uploadAction, scaleWH) =>
                handleImgchange(
                  file,
                  uploadAction,
                  scaleWH,
                  scope.$index,
                  index
                )
            "
            :ref="generateRef(scope.$index, index)"
          />
          <jtMusic
            v-if="showCellContent('jtMusic', scope.$index, index)"
            :src="scope.row[column.colId].value"
            :musicName="scope.row[column.colId].musicName"
            :tooltip="column.component.property.tooltip"
            :width="column.component.property.width"
            :height="column.component.property.height"
            :editable="column.editable && scope.row[column.colId].editable"
            :uploadAction="scope.row[column.colId].uploadAction"
            :supportTypes="column.component.property.supportTypes"
            :supportSize="column.component.property.supportSize"
            @delete="() => handleMusicDelete(scope.$index, index)"
            @success="
              (response) =>
                handleMusicUploadSuccess(scope.$index, index, response)
            "
            :ref="generateRef(scope.$index, index)"
          />
          <jtVideo
            v-if="showCellContent('jtVideo', scope.$index, index)"
            :src="scope.row[column.colId].value"
            :videoName="scope.row[column.colId].videoName"
            :tooltip="column.component.property.tooltip"
            :width="column.component.property.width"
            :height="column.component.property.height"
            :editable="column.editable && scope.row[column.colId].editable"
            :uploadAction="scope.row[column.colId].uploadAction"
            :supportTypes="column.component.property.supportTypes"
            :supportSize="column.component.property.supportSize"
            @delete="() => handleVideoDelete(scope.$index, index)"
            @success="
              (response) =>
                handleVideoUploadSuccess(scope.$index, index, response)
            "
            :ref="generateRef(scope.$index, index)"
          />
          <jtBigVideo
            v-if="showCellContent('jtBigVideo', scope.$index, index)"
            :src="scope.row[column.colId].value"
            :videoName="scope.row[column.colId].videoName"
            :tooltip="column.component.property.tooltip"
            :width="column.component.property.width"
            :height="column.component.property.height"
            :editable="column.editable && scope.row[column.colId].editable"
            :uploadAction="scope.row[column.colId].uploadAction"
            :supportTypes="column.component.property.supportTypes"
            :supportSize="column.component.property.supportSize"
            @delete="() => handleVideoDelete(scope.$index, index)"
            @success="
              (response) =>
                handleVideoUploadSuccess(scope.$index, index, response)
            "
            :ref="generateRef(scope.$index, index)"
          />
          <jtDistrict
            v-if="showCellContent('jtDistrict', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :placeholder="column.component.property.placeholder"
            :tooltip="column.component.property.tooltip"
            :minLength="column.component.property.minLength"
            :maxLength="column.component.property.maxLength"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtStatusButton
            v-if="showCellContent('jtStatusButton', scope.$index, index)"
            :compWidth="column.component.property.compWidth"
            :buttonText="column.component.property.buttonText"
            :tooltip="column.component.property.tooltip"
            :editable="column.editable && scope.row[column.colId].editable"
            @buttonSubmit="(tips) => handleButtonSubmit(scope.$index, tips)"
            :ref="generateRef(scope.$index, index)"
          />
          <jtRedirectPage
            v-if="showCellContent('jtRedirectPage', scope.$index, index)"
            :compWidth="column.component.property.compWidth"
            :pageName="column.component.property.pageName"
            :tooltip="column.component.property.tooltip"
            :editable="column.editable && scope.row[column.colId].editable"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            :ref="generateRef(scope.$index, index)"
          />
          <jtHtmlEdit
            v-if="showCellContent('jtHtmlEdit', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :compWidth="column.component.property.compWidth"
            :tooltip="column.component.property.tooltip"
            :defaultValue="column.component.property.defaultValue"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @htmlshow="
              (defauleValue, value) =>
                htmlshow(defauleValue, value, scope.$index, index)
            "
            :ref="generateRef(scope.$index, index)"
          />
          <jtLimitSingle
            v-if="showCellContent('jtLimitSingle', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :colId="column.colId"
            :tag="scope.row[column.colId].tag"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtLimitText
            v-if="showCellContent('jtLimitText', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :colId="column.colId"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtActions
            v-if="showCellContent('jtActions', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :colId="column.colId"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
            @openActions="(token) => openActions(token)"
          />
          <jtLimitGroup
            v-if="showCellContent('jtLimitGroup', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :colId="column.colId"
            :tag="scope.row[column.colId].tag"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
          />
          <jtTaoluDifficulty
            v-if="showCellContent('jtTaoluDifficulty', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :tag="scope.row[column.colId].tag"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
            @openDifficulty="
              (data) => openDifficulty(scope.$index, index, data)
            "
          />
          <jtTaoluRequired
            v-if="showCellContent('jtTaoluRequired', scope.$index, index)"
            :value="scope.row[column.colId].value"
            :tooltip="column.component.property.tooltip"
            :compWidth="column.component.property.compWidth"
            :options="
              scope.row[column.colId].options ||
              column.component.property.options
            "
            :rowId="scope.row.rowId"
            :tag="scope.row[column.colId].tag"
            @datas="(err, data) => handleData(err, scope.$index, index, data)"
            @enter="handleEnter"
            :ref="generateRef(scope.$index, index)"
            @openRequired="(data) => openRequired(scope.$index, index, data)"
          />
          <jtFile
            v-if="showCellContent('jtFile', scope.$index, index)"
            :src="scope.row[column.colId].value"
            :fileName="scope.row[column.colId].fileName"
            :tooltip="column.component.property.tooltip"
            :width="column.component.property.width"
            :height="column.component.property.height"
            :editable="column.editable && scope.row[column.colId].editable"
            :uploadAction="scope.row[column.colId].uploadAction"
            :types="column.component.property.types"
            :supportTypes="column.component.property.supportTypes"
            :maxLength="column.component.property.maxLength"
            :supportSize="column.component.property.supportSize"
            @delete="() => handleFileDelete(scope.$index, index)"
            @success="
              (response) =>
                handleFileUploadSuccess(scope.$index, index, response)
            "
            :ref="generateRef(scope.$index, index)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import _ from 'lodash'

import jtInput from '../input'
import jtEmail from '../email'
import jtPhone from '../phone'
import jtDate from '../date'
import jtTime from '../time'
import jtDateTime from '../datetime'
import jtIdCard from '../id-card'
import jtIdCardGlobal from '../id-cardglobal'
import jtSingleProject from '../single-project'
import jtGroupProject from '../group-project'
import jtSelect from '../select'
import jtImage from '../image'
import jtMusic from '../music'
import jtVideo from '../video'
import jtBigVideo from '../bigvideo'
import jtGroupSelect from '../group-select'
import jtDistrict from '../district'
import jtStatusButton from '../status-button'
import jtRedirectPage from '../redirect-page'
import jtHtmlEdit from '../html-edit'
import jtLimitSingle from '../limit-single'
import jtLimitText from '../limit-text'
import jtActions from '../actions'
import jtLimitGroup from '../limit-group'
import jtTaoluDifficulty from '../taolu-difficulty'
import jtTaoluRequired from '../taolu-required'
import jtFile from '../file'
import PageModel from '../../models/page'
import { tip } from '@/utils/tool'
import * as constants from '../../constants'

export default {
  name: 'jtTable',
  components: {
    jtInput,
    jtEmail,
    jtPhone,
    jtDate,
    jtTime,
    jtDateTime,
    jtIdCard,
    jtIdCardGlobal,
    jtSingleProject,
    jtGroupProject,
    jtSelect,
    jtImage,
    jtMusic,
    jtVideo,
    jtBigVideo,
    jtGroupSelect,
    jtDistrict,
    jtStatusButton,
    jtRedirectPage,
    jtHtmlEdit,
    jtLimitSingle,
    jtActions,
    jtLimitText,
    jtLimitGroup,
    jtTaoluDifficulty,
    jtTaoluRequired,
    jtFile,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    createButton: Boolean,
    copyButton: Boolean,
    deleteButton: Boolean,
  },
  computed: {
    columnsNumber() {
      return _.size(this.columns)
    },
    rowsNumber() {
      return _.size(this.rows)
    },
    showButtons() {
      return this.createButton || this.copyButton || this.deleteButton
    },
    tableMaxHeight() {
      return this.showButtons
        ? `${window.innerHeight - 260}px`
        : `${window.innerHeight - 200}px`
    },
  },
  data() {
    return {
      cellStatusArray: [],
      currentRow: -1,
      currentColumn: -1,
      enter: false,
      multipleSelection: [],
      createButtonDisabled: false,
      copyButtonDisabled: true,
      deleteButtonDisabled: true,
      itemkey: '0',
    }
  },
  methods: {
    //检查值是否为JSON
    checkValue(value, column) {
      let str = value
      const type = this.columns[column].component.type
      if (type === 'jtTaoluDifficulty') {
        if (value) {
          let obj = JSON.parse(value)
          str =
            obj.totalValue +
            '(' +
            obj.actionScore +
            '+' +
            obj.connectionScore +
            ')'
        }
      }
      if (type === 'jtTaoluRequired') {
        if (value) {
          let obj = JSON.parse(value)
          str = obj.count
        }
      }
      return str
    },
    /** 根据可编辑状态修改文字style */
    fontColor(r, c) {
      const editable =
        this.rows[r].editable &&
        this.columns[c].editable &&
        this.rows[r][this.columns[c].colId].editable

      if (!editable) {
        return { color: '#0000c0' }
      }
    },
    /** 生成uploadAction */
    buildUploadAction(componentType, pageId, containerId, rowId, colId) {
      return `/api/v2/page/${componentType}/upload?pageId=${pageId}&containerId=${containerId}&rowId=${rowId}&colId=${colId}`
    },
    /** 单元格单击事件 */
    async handleCellClick(row, column, cell, event) {
      const rowIdx = _.findIndex(this.rows, (item) => item.rowId === row.rowId)
      const colIdx = _.findIndex(
        this.columns,
        (item) => item.colId === column.property
      )
      const index = rowIdx * this.columnsNumber + colIdx
      if (
        rowIdx === this.currentRow &&
        colIdx === this.currentColumn &&
        this.cellStatusArray[index] !== false
      ) {
        return
      }

      if (this.cellStatusArray[index] === null) {
        this._closePreviousCellEditableStatus()
        this._updateCurrentRowAndCurrentColumn(rowIdx, colIdx)
        return
      }

      let arr = _.filter(
        this.rows,
        (item) => !_.isEmpty(item[this.columns[colIdx].colId].value)
      )

      // 集体项目当同一列其他行已经有数据时，直接发送数据，不用进入编辑状态
      let type = this.columns[colIdx].component.type
      if (
        type === 'jtGroupProject' ||
        type === 'jtGroupSelect' ||
        type === 'jtLimitGroup'
      ) {
        const index1 = _.findIndex(this.rows, (item) => {
          if (!_.isEmpty(item[this.columns[colIdx].colId].value)) {
            return true
          }
          return false
        })

        // 找到有数据的
        if (index1 !== -1) {
          let data = this.rows[index1][this.columns[colIdx].colId].value
          let isnotnull = !_.isEmpty(
            this.rows[rowIdx][this.columns[colIdx].colId].value
          )
          if (isnotnull) {
            data = ''
          }
          let arr = _.filter(
            this.rows,
            (item) => !_.isEmpty(item[this.columns[colIdx].colId].value)
          )
          if (!(type === 'jtLimitGroup' && arr.length === 1 && isnotnull)) {
            if (
              (type === 'jtGroupSelect' || type === 'jtLimitGroup') &&
              !isnotnull
            ) {
              if (type === 'jtGroupSelect') {
                let info = this.rows[rowIdx][this.columns[colIdx].colId].options
                if (info) {
                  if (info[0].value != '') {
                    let obj = _.find(info, (item) => item.value == data)
                    if (obj) {
                      this.$emit('datas', null, rowIdx, colIdx, data, () => {})
                    }
                  }
                } else {
                  this.$emit('datas', null, rowIdx, colIdx, data, () => {})
                }
              }
              if (type === 'jtLimitGroup') {
                let data1 = await PageModel.getGoodsList(
                  row[column.property].tag,
                  column.property,
                  row.rowId
                )
                let { goodsList } = data1
                let obj = _.find(goodsList, (item) => item['商品'] == data)
                if (obj) {
                  this.$emit('datas', null, rowIdx, colIdx, data, () => {})
                }
              }
            } else {
              this.$emit('datas', null, rowIdx, colIdx, data, () => {})
            }
            // this.$emit('datas', null, rowIdx, colIdx, data, () => {})
            this._closePreviousCellEditableStatus()
            this._updateCurrentRowAndCurrentColumn(rowIdx, colIdx)

            return
          }
        }
      }
      this._closePreviousCellEditableStatus()
      this._openCurrentCellEditableStatus(rowIdx, colIdx)
      this._focus(rowIdx, colIdx)
    },
    /** 根据要求显示单元格内容 */
    showCellContent(cellType, row, column) {
      const type = this.columns[column].component.type
      const index = row * this.columnsNumber + column
      if (
        _.includes(
          [
            'jtImage',
            'jtMusic',
            'jtVideo',
            'jtBigVideo',
            'jtStatusButton',
            'jtRedirectPage',
            'jtHtmlEdit',
            'jtFile',
          ],
          type
        )
      ) {
        if (cellType === null || cellType !== type) {
          return false
        } else {
          return true
        }
      }

      if (
        this.cellStatusArray[index] === null ||
        this.cellStatusArray[index] === false
      ) {
        return cellType === null
      } else {
        return cellType === type
      }
    },
    /** 数据处理 */
    handleData(err, row, column, data) {
      this.$emit(
        'datas',
        err,
        row,
        column,
        data,
        (success, otherColumnDataChange) => {
          if (!success) {
            this._focus(row, column)
            this.enter = false
            return
          }

          if (otherColumnDataChange) {
            this._initCellStatusArray()
          }
          if (this.enter) {
            this._goNext(row, column)
            this.enter = false
          } else {
            this._closePreviousCellEditableStatus()
          }
        }
      )
    },
    /**身份证唯一检测 */
    async handleIDCheck(obj, row, column) {
      const { gameId, teamId, olidCardOld, value } = obj
      let data = await PageModel.IDCheck(gameId, teamId, olidCardOld, value)
      if (data.errNo == 0) {
        this.handleData(null, row, column, value)
      } else {
        tip(data.errMsg)
      }
    },

    /** 提交状态按钮 */
    handleButtonSubmit(row, tips) {
      let { rowId } = this.rows[row]
      this.$emit('status-button-submit', rowId, tips)
    },
    /** 图片上传成功事件处理 */
    handleImageUploadSuccess(row, col, response) {
      this.$emit('image-upload-success', row, col, response)
    },
    /** 图片上传事件处理 */
    handleImgchange(file, uploadAction, scaleWH, row, col) {
      this.$emit('image-upload', file, uploadAction, scaleWH, row, col)
    },
    /** 删除图片事件处理 */
    handleImageDelete(row, col) {
      this.$emit('image-delete', row, col)
    },
    /** 音频上传成功事件处理 */
    handleMusicUploadSuccess(row, col, response) {
      this.$emit('music-upload-success', row, col, response)
    },
    /** 删除音频事件处理 */
    handleMusicDelete(row, col) {
      this.$emit('music-delete', row, col)
    },
    /** 视频上传成功事件处理 */
    handleVideoUploadSuccess(row, col, response) {
      this.$emit('video-upload-success', row, col, response)
    },
    /** 删除视频事件处理 */
    handleVideoDelete(row, col) {
      this.$emit('video-delete', row, col)
    },

        /** 文件上传成功事件处理 */
    handleFileUploadSuccess(row, col, response) {
      this.$emit('file-upload-success', row, col, response)
    },
    /** 删除文件事件处理 */
    handleFileDelete(row, col) {
      this.$emit('file-delete', row, col)
    },
    /** 回车事件处理 */
    handleEnter() {
      this.enter = true
    },
    /** 生成Ref */
    generateRef(row, column) {
      return `component_${row}_${column}`
    },
    /** 处理行选择改变事件 */
    handleSelectionChange(selection) {
      this.multipleSelection = selection
      let deletable = true
      _.forEach(selection, (item) => {
        deletable = deletable && item.deletable
      })

      const length = selection.length
      this.deleteButtonDisabled = length <= 0 || !deletable
      this.copyButtonDisabled = length !== 1
    },
    /** 处理增加一行按钮 */
    handleCreate() {
      this.$emit('create-a-line')
    },
    /** 处理拷贝一行按钮 */
    handleCopy() {
      this.$emit('copy-a-line', this.multipleSelection)
    },
    /** 处理删除一行按钮 */
    handleDelete() {
      this.$emit('delete-lines', this.multipleSelection)
    },
    /** 打开html编辑 */
    htmlshow(defauleValue, value, row, column) {
      this.$emit('htmlshow', defauleValue, value, row, column)
    },

    /** 打开新难度编辑 */
    openActions(token) {
      this.$emit('openActions', token)
    },

    /** 打开难度编辑 */
    openDifficulty(row, column, data) {
      this.$emit('openDifficulty', row, column, data)
    },

    /** 打开必选动作编辑 */
    openRequired(row, column, data) {
      this.$emit('openRequired', row, column, data)
    },
    /** 初始化表格组件可编辑状态数组 */
    _initCellStatusArray() {
      const size = this.rowsNumber * this.columnsNumber
      if (size === 0) {
        return
      }
      this.cellStatusArray = new Array(size)
      _.fill(this.cellStatusArray, null)
      if (!this.editable) {
        return
      }

      for (let r = 0; r < this.rowsNumber; r++) {
        for (let c = 0; c < this.columnsNumber; c++) {
          const index = r * this.columnsNumber + c
          const editable =
            this.rows[r].editable &&
            this.columns[c].editable &&
            this.rows[r][this.columns[c].colId].editable

          if (
            _.includes(
              [
                'jtImage',
                'jtMusic',
                'jtVideo',
                'jtBigVideo',
                'jtStatusButton',
                'jtRedirectPage',
                'jtHtmlEdit',
                'jtFile',
              ],
              this.columns[c].component.type
            )
          ) {
            continue
          }

          if (editable) {
            this.cellStatusArray[index] = false
          }
        }
      }
    },
    /** 获取编辑组件焦点 */
    _focus(row, col) {
      const ref = this.generateRef(row, col)
      const that = this
      _.delay(() => {
        that.$refs[ref][0].focus()
      }, constants.DELAY_TIME)
    },
    /** 焦点跳到下一个组件 */
    _goNext(row, col) {
      const length = this.cellStatusArray.length
      const index = row * this.columnsNumber + col
      for (let i = (index + 1) % length; i !== index; i = (i + 1) % length) {
        if (i === 0) {
          this._closePreviousCellEditableStatus()
          return
        }

        if (
          this.cellStatusArray[i] === null ||
          _.includes(
            [
              'jtImage',
              'jtMusic',
              'jtVideo',
              'jtBigVideo',
              'jtStatusButton',
              'jtRedirectPage',
              'jtHtmlEdit',
              'jtFile',
            ],
            this.columns[col].component.type
          )
        ) {
          continue
        }

        const newRow = _.floor(i / this.columnsNumber)
        const newCol = i % this.columnsNumber

        // 集体项目当同一列其他行已经有数据时，跳过该集体项目
        if (
          this.columns[newCol].component.type === 'jtGroupProject' ||
          this.columns[newCol].component.type === 'jtGroupSelect' ||
          this.columns[newCol].component.type === 'jtLimitGroup'
        ) {
          const index = _.findIndex(this.rows, (item) => {
            if (!_.isEmpty(item[this.columns[newCol].colId].value)) {
              return true
            }
            return false
          })

          if (index !== -1) {
            continue
          }
        }

        this._closePreviousCellEditableStatus()
        this._openCurrentCellEditableStatus(newRow, newCol)
        this._focus(newRow, newCol)
        return
      }
    },
    /** 关闭上一个单元格编辑状态 */
    _closePreviousCellEditableStatus() {
      if (this.currentRow >= 0 && this.currentColumn >= 0) {
        const index = this.currentRow * this.columnsNumber + this.currentColumn
        if (this.cellStatusArray[index] === true) {
          this.$set(this.cellStatusArray, index, false)
        }
      }
    },
    /** 打开当前单元格编辑状态 */
    _openCurrentCellEditableStatus(row, col) {
      const index = row * this.columnsNumber + col
      if (this.cellStatusArray[index] === false) {
        this.$set(this.cellStatusArray, index, true)
        this._updateCurrentRowAndCurrentColumn(row, col)
      }
    },
    /** 更新当前行和当前列索引 */
    _updateCurrentRowAndCurrentColumn(row, col) {
      this.currentRow = row
      this.currentColumn = col
    },
  },
  created() {
    this._initCellStatusArray()
  },

  watch: {
    /** 监听行数变化，如果行数增加，对应的单元格状态数组也要发生改变 */
    // eslint-disable-next-line no-dupe-keys
    rows() {
      // this.itemkey = Math.random()
      const length = this.rowsNumber * this.columnsNumber
      if (this.cellStatusArray.length !== length) {
        this._initCellStatusArray()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.table-comp {
  display: block;
}

.component-container >>> .el-table th {
  padding: 8px 0;
}

.component-container >>> .el-table td {
  padding: 8px 0;
}

.button {
  margin: 10px 5px;
}

.component-container >>> .el-table__body tr.current-row>td {
  background-color: #daefff;
}

.cell-content {
  height: 40px;
}

.component-container >>> .el-table .cell {
  word-wrap: break-word;
  word-break: normal;
}

.component-container >>> .el-table .isrequired {
  color: #dd6161;
}
</style>
